(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/deposit.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/deposit.js');
'use strict';

const {
  DepositComponent
} = svs.accountservicesReact.deposit;
const {
  DepositReduxProvider
} = svs.accountservicesReact.deposit.store;
const {
  ErrorBoundary
} = svs.components.errorBoundary;
const Deposit = _ref => {
  let {
    instantPay,
    hasNoProfileLinkSwish,
    isHideDepositLimits,
    isPlayerRegistration = false,
    swedbankPayProps
  } = _ref;
  return React.createElement(ErrorBoundary, null, React.createElement(DepositReduxProvider, null, React.createElement(DepositComponent, {
    hasNoProfileLinkSwish: hasNoProfileLinkSwish,
    instantPay: instantPay,
    isHideDepositLimits: isHideDepositLimits,
    isPlayerRegistration: isPlayerRegistration,
    swedbankPayProps: swedbankPayProps
  })));
};
svs.accountservicesReact.deposit.Deposit = Deposit;

 })(window);